import { routerMiddleware } from 'react-router-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import { initializeStore } from '@orange-marmalade/paginate-this';

import createMiddleware from './client';
import reducer from './reducer';

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Add the reducer to your store on the `routing` key
const middleware = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  undefined,
  composeEnhancers(applyMiddleware(createMiddleware(), thunk, middleware))
);

initializeStore(store);

// if (module.hot) {
// Enable Webpack hot module replacement for reducers
// module.hot.accept('./reducer', () => {
//   const nextRootReducer = require('./reducer');
//   store.replaceReducer(nextRootReducer);
// });

//   module.hot.accept();
// }

export { history, store };



// WEBPACK FOOTER //
// ./src/middleware/index.js